"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.208 12.557a2.55 2.55 0 0 0-2.55 2.55.7.7 0 1 1-1.4 0 3.95 3.95 0 0 1 3.95-3.95H8.46a.7.7 0 1 1 0 1.4zm1.336-7.036a1.776 1.776 0 1 1 0 3.552 1.776 1.776 0 0 1 0-3.552m3.176 1.776a3.176 3.176 0 1 0-6.352 0 3.176 3.176 0 0 0 6.352 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.405 8.842a1.954 1.954 0 0 1 2.764 2.764l-3.779 3.778a1.2 1.2 0 0 1-.707.343l-1.21.143a1.2 1.2 0 0 1-1.333-1.332l.143-1.21a1.2 1.2 0 0 1 .343-.708zm1.774.99a.554.554 0 0 0-.784 0l-3.73 3.729-.105.89.89-.106 3.729-3.73a.554.554 0 0 0 0-.783",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserWithPencil20.js.map